import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /permatitle-video/video/id/
const path = ['web', process.env.FOLDER_LAYOUTS, 'audio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { id } = context.query;

    const path = ['web', process.env.FOLDER_LAYOUTS, 'audio'];

    if (!Number.isInteger(parseInt(id))) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
